import React from 'react';
import appLabel from '../../../../config/appLabel';
import {
    Button,
    Typography,
    Card,
    Modal,
    Space,
    Row,
    Form,
    Input,
    Divider,
} from "antd";
import appStatic from '../../../../config/appStatic';

const { Text, Title } = Typography;

export default function ModalJournalEntry(props) {

    const {
        isModalOpen,
        setIsModalOpen,
        modalDetail,
        journalEntryDetail
    } = props
    const { monthList } = appStatic
    const [useForm] = Form.useForm();
    const handleOk = () => {
        setTimeout(() => {
            setIsModalOpen(false);
        }, 3000);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Modal
            open={isModalOpen}
            // centered
            onOk={handleOk}
            onCancel={handleCancel}
            closeIcon={false}
            width={1000}
            footer={[
                <Button
                    key="back"
                    style={{
                        width: "20%",
                        marginLeft: "auto",
                        boxShadow: "0px 0px 10px 5px rgba(0,0,0,0.1)",
                        backgroundColor: "#fff",
                        hoverBackground: "#AD4EA7",
                        padding: 0
                    }}
                    onClick={handleCancel}

                >Close</Button>
            ]}
        >
            <Space
                direction="vertical"
                style={{
                    display: 'flex',
                }}
            >
                <Title level={3} style={{ padding: 0, margin: 0 }}>{appLabel.journalEntry}</Title>
                <Divider style={{ padding: 0, margin: 0 }}>
                </Divider>
                <Form
                    form={useForm}
                    layout="vertical"
                >
                    <Card
                        style={{
                            marginBottom: "2%",
                            boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
                        }}
                    >
                        <Row style={{ justifyContent: "space-between" }}>


                            <Form.Item label={<Text strong>{appLabel.branch}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail.branch}
                                />
                            </Form.Item>
                            <Form.Item label={<Text strong>{appLabel.entryId}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail?.entryId
                                        ? modalDetail?.entryId
                                        : "-"}
                                />
                            </Form.Item>

                        </Row>

                        <Row style={{ justifyContent: "space-between" }}>
                            <Form.Item label={<Text strong>{appLabel.transactionId}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail?.transactionId
                                        ? modalDetail?.transactionId
                                        : "-"}
                                />
                            </Form.Item>
                            <Form.Item label={<Text strong>{appLabel.transactionDate}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail?.transactionDate
                                        ? modalDetail?.transactionDate
                                        : "-"}
                                />
                            </Form.Item>
                        </Row>
                        <Row style={{ justifyContent: "space-between" }}>
                            <Form.Item label={<Text strong>{appLabel.type}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail?.type
                                        ? modalDetail?.type
                                        : "-"}
                                />
                            </Form.Item>
                            <Form.Item label={<Text strong>{appLabel.account}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail?.account
                                        ? modalDetail?.account
                                        : "-"}
                                />
                            </Form.Item>
                        </Row>
                        <Row style={{ justifyContent: "space-between" }}>
                            <Form.Item label={<Text strong>{(modalDetail?.credit === "-") ? appLabel.debit : appLabel.credit}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={(modalDetail?.credit === "-") ? modalDetail.debit : modalDetail.credit}
                                />
                            </Form.Item>
                            <Form.Item label={<Text strong>{appLabel.createdBy}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={modalDetail.createdBy}
                                />
                            </Form.Item>
                        </Row>
                        <Row style={{ justifyContent: "space-between" }}>
                            <Form.Item label={<Text strong>{appLabel.createdOn}</Text>}>
                                <Input
                                    style={{ width: "30vh", fontWeight: "bold" }}
                                    disabled
                                    value={journalEntryDetail?.createdDate
                                        ? (`${journalEntryDetail?.createdDate[2]} ${monthList[journalEntryDetail?.createdDate[1] - 1]} ${journalEntryDetail?.createdDate[0]}`)
                                        : "-"}
                                />
                            </Form.Item>
                        </Row>
                    </Card>
                </Form>
            </Space>
        </Modal>
    )
}
